import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/boards')({

}).lazy(() => import('./boards.lazy').then((d) => d.Route));
